
















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { safeWindow } from 'frontend/utils/window';
import { mapGetters, mapState } from 'vuex';
import { PlanType, User } from 'frontend/types';
import MathSvg from 'frontend/views/premium/paywall/svgs/MathSvg.vue';
import DataAnalysisSvg from 'frontend/views/premium/paywall/svgs/DataAnalysisSvg.vue';
import ComputerScienceSvg from 'frontend/views/premium/paywall/svgs/ComputerScienceSvg.vue';
import ProgrammingSvg from 'frontend/views/premium/paywall/svgs/ProgrammingSvg.vue';
import ScienceAndEngineeringSvg from 'frontend/views/premium/paywall/svgs/ScienceAndEngineeringSvg.vue';
import LightningSvg from 'frontend/views/premium/paywall/svgs/LightningSvg.vue';

@Component({
  components: {
    LightningSvg,
    MathSvg,
    DataAnalysisSvg,
    ComputerScienceSvg,
    ProgrammingSvg,
    ScienceAndEngineeringSvg,
  },
  computed: {
    ...mapGetters('pageHeader', ['isMobile']),
    ...mapGetters('paywall', ['paywallPlans']),
    ...mapState('globals', ['user']),
    ...mapState('paywall', ['paywall_type']),
    ...mapState('pageHeader', ['context']),
    ...mapState('viewedReferralModal', ['userHasSeenReferralModal']),
  },
})
export default class PlanCard extends Vue {
  @Prop(String) private readonly planTitle!: string;
  @Prop(String) private readonly price!: string;
  @Prop(String) private readonly strikethroughPrice?: string | undefined;
  @Prop(String) private readonly checkoutUrl!: Location;
  @Prop(String) private readonly planType!: PlanType;
  @Prop(Boolean) private isPopular!: boolean;
  @Prop(Boolean) private readonly shouldShowDiscount: boolean = false;

  private user!: User;

  private get isMathFoundationsPlan(): boolean {
    return this.planType === PlanType.mathFoundations;
  }

  private get mathDescription(): string {
    if (this.isMathFoundationsPlan) {
      return 'Mathematical Thinking, Logic, Algebra, Geometry, and Calculus';
    }
    return 'Math';
  }

  @Watch('startTrialCtaClickedAt')
  private handleClick() {
    if (!this.user.is_authenticated) {
      this.$store.dispatch('signupModal/signup');
    } else {
      const win = safeWindow();
      if (win) {
        win.location = this.checkoutUrl;
      }
    }
  }
}
